import { defineStore } from 'pinia'
import api from '@/services/api'

export const useClinicsStore = defineStore('clinics', {
  state: () => ({
    clinics: [],
    selectedClinic: null,
    loading: false,
    error: null,
    lastFetch: null,
    cacheTime: 5 * 60 * 1000
  }),

  getters: {
    totalClinics: (state) => state.clinics.length,
    isCacheValid: (state) => {
      if (!state.lastFetch) return false
      return Date.now() - state.lastFetch < state.cacheTime
    }
  },

  actions: {
    async fetchClinics(force = false) {
      if (!force && this.isCacheValid && this.clinics.length > 0) {
        return this.clinics
      }

      this.loading = true
      this.error = null

      try {
        const response = await api.get('/api/clinics')

        if (response.data && response.data.success && response.data.data && response.data.data.clinics) {
          this.clinics = response.data.data.clinics
          this.lastFetch = Date.now()
          return this.clinics
        } else {
          throw new Error('Estructura de respuesta inválida')
        }
      } catch (error) {
        this.error = error.response?.data?.error || error.message || 'Error de conexión'
        throw error
      } finally {
        this.loading = false
      }
    },

    selectClinic(clinic) {
      this.selectedClinic = clinic
    },

    getClinicById(id) {
      return this.clinics.find(c => c.id == id) || null
    },

    clearClinics() {
      this.clinics = []
      this.selectedClinic = null
      this.error = null
      this.lastFetch = null
    }
  }
})
